import { Button } from '@talentmesh/ui/components/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { cn } from '@talentmesh/ui/lib/utils';

import { type MRT_Column, type MRT_RowData, type MRT_TableInstance } from '../../types';
import classes from './MRT_ColumnPinningButtons.module.css';

interface Props<TData extends MRT_RowData> {
    column: MRT_Column<TData>;
    table: MRT_TableInstance<TData>;
}

export const MRT_ColumnPinningButtons = <TData extends MRT_RowData>({ column, table }: Props<TData>) => {
    const {
        options: {
            icons: { IconPinned, IconPinnedOff },
            localization,
        },
    } = table;
    return (
        <div className={cn('mrt-column-pinning-buttons flex gap-0.5', classes.root)}>
            {column.getIsPinned() ? (
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            className="text-muted-foreground h-9 w-9"
                            onClick={() => column.pin(false)}
                            size="icon-2xs"
                            variant="ghost"
                        >
                            <IconPinnedOff className="size-4" />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent side="bottom">{localization.unpin}</TooltipContent>
                </Tooltip>
            ) : (
                <>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                className="text-muted-foreground h-9 w-9"
                                onClick={() => column.pin('left')}
                                size="icon-2xs"
                                variant="ghost"
                            >
                                <IconPinned className={cn('size-4', classes.left)} />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent side="bottom">{localization.pinToLeft}</TooltipContent>
                    </Tooltip>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <Button
                                className="text-muted-foreground h-9 w-9"
                                onClick={() => column.pin('right')}
                                size="icon-2xs"
                                variant="ghost"
                            >
                                <IconPinned className={cn('size-4', classes.right)} />
                            </Button>
                        </TooltipTrigger>
                        <TooltipContent side="bottom">{localization.pinToRight}</TooltipContent>
                    </Tooltip>
                </>
            )}
        </div>
    );
};
